/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IRegionTileSelectorData } from './region-tile-selector.data';
import { IRegionTileSelectorProps } from './region-tile-selector.props.autogenerated';

export interface IRegionTileSelectorViewProps extends IRegionTileSelectorProps<IRegionTileSelectorData> {}

/**
 *
 * RegionTileSelector component
 * @extends {React.PureComponent<IRegionTileSelectorProps<IRegionTileSelectorData>>}
 */
class RegionTileSelector extends React.PureComponent<IRegionTileSelectorProps<IRegionTileSelectorData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default RegionTileSelector;
